import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { getCurrentProfilePage } from '../selectors'
import { profileMenu } from '../constants'
import {
  AddonsPage,
  MyPage,
  PackagePage,
  SavedAdsPage,
  SavedProfilesPage,
  SavedFiltersPage,
  AdsPage,
  Notifications
} from '../components/pages'
import Router from 'next/router'
import { setAppInternalTransitionFunc } from 'SRC/modules/common/actions'
import { setProfileLoading } from '../actions'

export class ProfileRouter extends React.Component {
  constructor(props) {
    super(props)

    if (Router.router) {
      Router.router.events.on('routeChangeStart', this.onRouteChangeStartHandler)
      Router.router.events.on('routeChangeComplete', this.onRouteChangeCompleteHandler)
    }
  }

  componentDidMount() {
    this.props.setAppInternalTransitionFunc(this.isInternalTransition)
  }

  componentWillUnmount() {
    this.props.setAppInternalTransitionFunc(null)
  }

  onRouteChangeStartHandler = url => {
    if (this.isInternalTransition(url)) {
      this.showSpinner()
    }
  }

  onRouteChangeCompleteHandler = () => {
    this.hideSpinner()
  }

  isInternalTransition = url => /^\/profil.*/.test(url)

  showSpinner = () => {
    this.props.setProfileLoading(true)
  }

  hideSpinner = () => {
    this.props.setProfileLoading(false)
  }

  getRenderComponent = page => {
    switch (page) {
      case profileMenu.package.code:
        return PackagePage
      case profileMenu.addons.code:
        return AddonsPage
      case profileMenu.ads.code:
        return AdsPage
      case profileMenu.savedAds.code:
        return SavedAdsPage
      case profileMenu.savedProfiles.code:
        return SavedProfilesPage
      case profileMenu.savedFilters.code:
        return SavedFiltersPage
      case 'notifikacije':
        return Notifications
      default:
        return MyPage
    }
  }

  render() {
    const Component = this.getRenderComponent(this.props.currentPage)
    return [
      <Component key='content' />
    ]
  }
}

const mapStateToProps = state => ({ currentPage: getCurrentProfilePage(state) })

ProfileRouter.propTypes = {
  currentPage: PropTypes.string,
  setAppInternalTransitionFunc: PropTypes.func.isRequired,
  setProfileLoading: PropTypes.func.isRequired
}

export default connect(mapStateToProps, { setAppInternalTransitionFunc, setProfileLoading })(ProfileRouter)
